import { useEffect } from "react";
import {
  useUserApplicationsStore,
  type UserApplication,
} from "@/stores/userApplicationsStore";

export type { UserApplication };

export function useUserApplications() {
  const applications = useUserApplicationsStore((state) => state.applications);
  const loading = useUserApplicationsStore((state) => state.loading);
  const error = useUserApplicationsStore((state) => state.error);
  const loadApplications = useUserApplicationsStore((state) => state.loadApplications);

  useEffect(() => {
    void loadApplications();
  }, [loadApplications]);

  return { applications, loading, error };
}
